var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopypaste = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128pt",
    height: "128pt",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00abe6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m35.297 101.13v-78.402h-4c-4.418 0-8 3.582-8 8v78.402c0 2.1211 0.84375 4.1562 2.3438 5.6562s3.5352 2.3438 5.6562 2.3438h53.602-0.003907c2.125 0 4.1562-0.84375 5.6602-2.3438 1.5-1.5 2.3398-3.5352 2.3398-5.6562v-4h-53.598c-1.0625 0-2.0781-0.42188-2.8281-1.1719s-1.1719-1.7695-1.1719-2.8281z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.852 8.7617v13.238h13.242z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.852 26c-1.1055 0-2-0.89453-2-2v-17.238h-42.52c-4.418 0-8 3.5781-8 8v78.398c0 2.1211 0.84375 4.1562 2.3438 5.6562s3.5352 2.3438 5.6562 2.3438h53.602c2.1211 0 4.1562-0.84375 5.6562-2.3438s2.3438-3.5352 2.3438-5.6562v-67.16z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopypaste);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/copypaste.941e0eac97e94c378433cee0f81d7134.svg";